module.exports = __webpack_public_path__ + "static/media/layout3-img.ea7bdb5e.svg";